import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var ExternalInteractorBase = /*#__PURE__*/_createClass(function ExternalInteractorBase(container) {
  _classCallCheck(this, ExternalInteractorBase);
  this.container = container;
  this.type = 0;
});